/**
 * Keep focused page fields visible above the keyboard.
 * Client-only: Visual Viewport and document listeners never run during SSR.
 */
import { startKeyboardAwareScroll } from '~/utils/keyboardAwareScroll'
import { startStoreVisualViewport } from '~/utils/storeVisualViewport'

export default defineNuxtPlugin({
  name: 'keyboard-aware-scroll',
  setup() {
    startStoreVisualViewport()
    startKeyboardAwareScroll()
  },
})
